__turbopack_context__.v({
  "active": "AmortizationChart-module-scss-module__gxFnjW__active",
  "chartPlaceholder": "AmortizationChart-module-scss-module__gxFnjW__chartPlaceholder",
  "chartPlaceholderText": "AmortizationChart-module-scss-module__gxFnjW__chartPlaceholderText",
  "collapsibleContent": "AmortizationChart-module-scss-module__gxFnjW__collapsibleContent",
  "collapsibleTrigger": "AmortizationChart-module-scss-module__gxFnjW__collapsibleTrigger",
  "collapsibleTriggerIcon": "AmortizationChart-module-scss-module__gxFnjW__collapsibleTriggerIcon",
  "collapsibleTriggerText": "AmortizationChart-module-scss-module__gxFnjW__collapsibleTriggerText",
  "collapsibleWrapper": "AmortizationChart-module-scss-module__gxFnjW__collapsibleWrapper",
  "component": "AmortizationChart-module-scss-module__gxFnjW__component",
  "content": "AmortizationChart-module-scss-module__gxFnjW__content",
  "open": "AmortizationChart-module-scss-module__gxFnjW__open",
  "quickSelectButton": "AmortizationChart-module-scss-module__gxFnjW__quickSelectButton",
  "quickSelectButtons": "AmortizationChart-module-scss-module__gxFnjW__quickSelectButtons",
  "summaryStat": "AmortizationChart-module-scss-module__gxFnjW__summaryStat",
  "summaryStatLabel": "AmortizationChart-module-scss-module__gxFnjW__summaryStatLabel",
  "summaryStatValue": "AmortizationChart-module-scss-module__gxFnjW__summaryStatValue",
  "summaryStats": "AmortizationChart-module-scss-module__gxFnjW__summaryStats",
  "tableCellBold": "AmortizationChart-module-scss-module__gxFnjW__tableCellBold",
  "tableCellRight": "AmortizationChart-module-scss-module__gxFnjW__tableCellRight",
  "tableContainer": "AmortizationChart-module-scss-module__gxFnjW__tableContainer",
  "tableFooterSticky": "AmortizationChart-module-scss-module__gxFnjW__tableFooterSticky",
  "tableHeaderSticky": "AmortizationChart-module-scss-module__gxFnjW__tableHeaderSticky",
  "viewToggle": "AmortizationChart-module-scss-module__gxFnjW__viewToggle",
  "viewToggleButton": "AmortizationChart-module-scss-module__gxFnjW__viewToggleButton",
  "yearSelector": "AmortizationChart-module-scss-module__gxFnjW__yearSelector",
  "yearSelectorHeader": "AmortizationChart-module-scss-module__gxFnjW__yearSelectorHeader",
  "yearSelectorLabel": "AmortizationChart-module-scss-module__gxFnjW__yearSelectorLabel",
  "yearSelectorValue": "AmortizationChart-module-scss-module__gxFnjW__yearSelectorValue",
});
